import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  wrapper: {
    width: '100%',
    borderRadius: theme.spacing(1),

    '& .recharts-wrapper *': {
      outline: 'none !important',
    },
  },
}));
